import { datadogRum } from '@datadog/browser-rum'
import { createClient } from '@rgrd/event-library'
import { events } from '@rgrd/event-library/generated'
import { amplitudeProvider } from '@rgrd/event-library/providers/amplitude'
import { datadogProvider } from '@rgrd/event-library/providers/datadog'

import { getRegardWindowValue } from '~/shared/window'
import { shouldBypassAuthForE2E } from '~/shell/config'
import { amplitude } from '~/shell/integrations/amplitude'

/**
 * Builds an event client whose surface controls its available events and `service` property.
 */
export const createTrackClient = <const Surface extends string>(
  surface: Surface,
) =>
  createClient({
    contexts: [surface],
    events,
    providers: [amplitudeProvider(amplitude), datadogProvider(datadogRum)],
    globalContext: () => ({
      service: surface,
      version: getRegardWindowValue('version') ?? '',
    }),
    disabled: () => shouldBypassAuthForE2E,
  })
